export enum ChatStatus {
  Started = "started",
  Successful = "successful",
  Failed = "failed",
}
